import React, {Component} from 'react';
import Page from '../../components/Page';
import DoughnutChart from '../../components/DoughnutChart';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './styles.css';
import moment from 'moment';


import {getAuthenticatedUser} from '../../actions/authentication';
import {getHolidays} from '../../actions/holidays';

class Home extends Component {

  componentWillMount() {
      this.props.dispatch(getAuthenticatedUser());
      this.props.dispatch(getHolidays());
  }

  render() {

      let vacationDaysPerYear = this.props.user.vacationDaysPerYear || 21;
      let vacationDaysAvailable = this.props.user.vacationDaysAvailable || 21;
      let vacationDaysOff = 0;
      if (vacationDaysPerYear > vacationDaysAvailable) {
          vacationDaysOff = vacationDaysPerYear - vacationDaysAvailable;
      }
      let now = new Date();
      let currentYear = now.getFullYear();

      let data = {
          datasets: [{
              data: [vacationDaysAvailable, vacationDaysOff],
              backgroundColor: ['#f59e0b', '#e4e8e3'],
              borderColor: '#ffffff',
              borderWidth: 3,
              hoverBackgroundColor: ['#d97706', '#d4d9d3'],
          }],
          labels: [
              'Available days',
              'Days taken',
          ]
      };

      let options = {
          responsive: true,
          maintainAspectRatio: true,
          cutoutPercentage: 70,
          legend: {
              position: 'bottom',
              labels: { boxWidth: 12, padding: 16, fontColor: '#6b7c82', fontSize: 13 },
          },
          tooltips: { bodyFontSize: 13, cornerRadius: 8, xPadding: 10, yPadding: 8 },
      };

      let sortedHolidays = [];

      this.props.holidays.forEach((holiday) => {
          if (holiday.year && holiday.year !== currentYear) {
              return;
          }
          let date = new Date(currentYear, holiday.month - 1, holiday.day);
          sortedHolidays.push({name: holiday.name, date: date});
      });

      sortedHolidays.sort((a, b) => a.date - b.date);

      let holidays = sortedHolidays.map((holiday, index) => {
          let date = holiday.date;
          let isPast = moment(date).isBefore(now, 'day');
          let dateStyle = {color: moment(date).isoWeekday() < 6 ? 'var(--success)' : 'var(--danger)'};
          if (isPast) { dateStyle = {color: 'var(--muted)'}; }

          return (
              <div key={'holiday_' + index} className={'Holiday-Row' + (isPast ? ' is-past' : '')}>
                  <div className="h-name"><i className="fa fa-star" aria-hidden="true" /> {holiday.name}</div>
                  <div className="h-date" style={dateStyle}>{moment(date).format('ddd, DD MMM YYYY')}</div>
              </div>
          );
      });

      return (
        <Page {...this.props} >
            <div className="col-xs-12">
                <div className="Home-Hello">
                    <h2>Hello, {this.props.user.firstName || ''} {this.props.user.lastName || ''}</h2>
                    <span className="year">{currentYear}</span>
                </div>

                <div className="Stat-Grid">
                    <div className="Stat">
                        <span className="lbl">Days per year</span>
                        <span className="val">{vacationDaysPerYear}</span>
                    </div>
                    <div className="Stat is-accent">
                        <span className="lbl">Available</span>
                        <span className="val">{vacationDaysAvailable} <small>days left</small></span>
                    </div>
                    <div className="Stat is-brand">
                        <span className="lbl">Taken</span>
                        <span className="val">{vacationDaysOff} <small>days used</small></span>
                    </div>
                </div>

                <div className="Card Chart-Card">
                    <div className="Title"><span>Vacation balance</span></div>
                    <div className="Chart-Holder">
                        <DoughnutChart data={data} options={options} id="vacation-chart"/>
                    </div>
                </div>

                <div className="Card">
                    <div className="Title"><span>Official holidays · {currentYear}</span></div>
                    <div className="Holiday-List">
                        {holidays.length ? holidays :
                            <div className="Empty"><i className="fa fa-calendar-o" /><div className="t">No holidays yet</div></div>}
                    </div>
                </div>
            </div>
        </Page>
    );
  }
}

Home.propTypes = {
    user: PropTypes.object,
    holidays: PropTypes.arrayOf(PropTypes.object),
};

Home.defaultProps = {
    user: {},
    holidays: [],
};


function mapStateToProps(state) {
    return {
        user: state.authentication.user,
        holidays: state.holidays,
    };
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/screens/Home/index.js